import { useState } from 'react';
import { getBooleanEnvVar } from '@/utils/envUtils';
import { Banner } from '@/components/ui/banner';

export function MaintenanceBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !getBooleanEnvVar('VITE_MAINTENANCE_BANNER')) return null;

  return (
    <Banner tone="info" title="We're rolling out an update" onDismiss={() => setDismissed(true)}>
      You might see some downtime over the next hour. Thanks for bearing with us, it'll be worth the wait!
    </Banner>
  );
}
